import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations from './translations';

i18n.use(initReactI18next).init({
  lng: localStorage.getItem('lang') || 'EN', // if you're using a language detector, do not define the lng option
  fallbackLng: 'EN',
  debug: false,
  resources: translations,
});

i18n.on('languageChanged', (lang) => {
  localStorage.setItem('lang', lang);
});
